import { graphql, useStaticQuery } from 'gatsby';
import React, { FunctionComponent, useState } from 'react';
import { useScreenSize } from '../../hooks/useScreenSize';
import { SanityResource } from '../../types/common';
import { urlFor } from '../../utils/imageBuilder';
import { DownloadIcon, ExternalLinkIcon } from '../Icons';
import './styles.scss';

type ResourceProps = {
  resource: SanityResource;
};

const textSize = 140;

function formatText(text: string) {
  const limitedText = text.slice(0, textSize);
  return text.length > textSize ? limitedText + '...' : limitedText;
}

const ResourceCard: FunctionComponent<ResourceProps> = ({ resource }) => {
  const [showMore, setShowMore] = useState(false);
  const { isMobile } = useScreenSize();
  const imgSize = isMobile ? 80 : 150;

  const { sanityLabels } = useStaticQuery(graphql`
    {
      sanityLabels {
        generalLabels {
          readMore
          readLess
        }
      }
    }
  `);

  const readMore = sanityLabels?.generalLabels?.readMore ?? 'Read more';
  const readLess = sanityLabels?.generalLabels?.readLess ?? 'Read less';

  return (
    <div className='resource-card'>
      <img
        src={urlFor(resource.image).width(imgSize).height(imgSize).quality(90).url()}
        alt={resource.image.alt}
      />
      <div className='resource-card-header'>
        <span>{resource.tag.name}</span>
        <p><strong>{resource.title}</strong></p>
      </div>
      <p className='resource-card-description'>
        {showMore ? resource.description : formatText(resource.description)}
        {resource.description.length > textSize && (

          <button type='button' onClick={() => setShowMore(current => !current)}>
            {showMore ? readLess : readMore}
          </button>
        )}
      </p>

      <div className='resource-card-button'>
        {resource.action.map((action, index) => {
          if (action.type === 'external' && action.externalLink) {
            return (
              <a
                key={index}
                href={action.externalLink}
                target='_blank'
                rel='noreferrer noopener'
              >
                {action.customLabel ? action.customLabel : 'Visit website'}
                <ExternalLinkIcon />
              </a>
            );
          }

          if (action.type === 'download' && action.file.asset.url) {
            return (
              <a
                key={index}
                href={`${action.file.asset.url}?dl=`}
                download
              >
                {action.customLabel ? action.customLabel : 'Download'}
                <DownloadIcon />
              </a>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
}

export default ResourceCard;
